<template>
    <require from="../../parent-child-select/parent-child-select"></require>
    <parent-child-select
            items.bind="selectedObjectService.selectedObject.read_right"
            objecttypetoadd.bind="'read_right'"
            sortable.bind="'true'"
    >
    </parent-child-select>
</template>
